import { createContext } from 'react';

const capturaContext = createContext();

export default capturaContext;